import React from 'react';
import { CtaButton } from './ui/CtaButton';
import { BrandMark } from './ui/BrandMark';
import { WHATSAPP_ORDER_LINK } from '../utils/whatsapp';
const navLinks = [{
  label: 'Sabores',
  href: '#sabores'
}, {
  label: 'Cómo pedir',
  href: '#como-pedir'
}, {
  label: 'Cajas',
  href: '#cajas'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export function Navbar() {
  return <header className="sticky top-0 z-40 w-full border-b border-white/10 bg-night-900/90 backdrop-blur" data-id="element-77" data-mp="sd599n1jhh70">
      <div className="mx-auto flex h-[72px] w-full max-w-6xl items-center justify-between gap-4 px-4 sm:px-6" data-id="element-78" data-mp="jmoumsl8x1i">
        <a href="#top" className="flex items-center gap-3" data-id="element-79" data-mp="ej4jvjwh96jb">
          <BrandMark className="h-12 w-12" labelClassName="text-[15px]" data-id="element-80" data-mp="ekpe18evqngn" />
          <span className="flex flex-col leading-none" data-id="element-81" data-mp="9jjjd51nsq4h">
            <span className="font-display text-lg font-semibold uppercase tracking-[0.16em] text-white sm:text-xl" data-id="element-82" data-mp="1pyb02kpg08xy">
              Blue &amp; White
            </span>
            <span className="mt-1.5 text-[10px] uppercase tracking-[0.28em] text-gold-400" data-id="element-83" data-mp="1kz87w0uk9x7e">
              Empanadas Argentinas
            </span>
          </span>
        </a>

        <nav aria-label="Secciones" className="hidden items-center gap-7 md:flex" data-id="element-84" data-mp="em9b0cl6szu4">
          {navLinks.map(link => <a key={link.href} href={link.href} className="text-[13px] font-medium text-white/70 transition-colors hover:text-aqua-300" data-id="element-85" data-mp="jnf44birep46">
              {link.label}
            </a>)}
        </nav>

        <CtaButton href={WHATSAPP_ORDER_LINK} size="sm" track="whatsapp-header-click" data-id="element-86" data-mp="3s1nure1q15tp">
          <span className="hidden sm:inline" data-id="element-87" data-mp="ul2ske26vif">Pedir por WhatsApp</span>
          <span className="sm:hidden" data-id="element-88" data-mp="5n4bp41sx2gw">Pedir</span>
        </CtaButton>
      </div>
    </header>;
}